export class BadgesConfig {
  hideLabel?: boolean;
  isClickable?: boolean;
  cssClass?: string;
  selectedBadge?: number;
}
